import React from 'react';

interface Props {
  email: string;
}

export const AssociateAccountIntroduction = ({ email }: Props) => (
  <div className="flex flex-col gap-7 leading-[22px] text-dark-gray">
    <p className="flex flex-col text-base">
      Nous avons trouvé un compte Darty rattaché à l&rsquo;adresse :<span className="font-bold">{email}</span>
    </p>
    <p>Associez le maintenant à votre compte Paypal pour faciliter tous vos futurs achats.</p>
    <p>Identifiez vous avec votre mot de passe ou recevez un code de connexion par e-mail et c&rsquo;est réglé !</p>
  </div>
);
